const styles = {
  root: {
    textTransform: 'none',
  },
};

export default styles;
